module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Kinchaku Drawstring Bag")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Shimacho Quilt")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zabuton Floor Cushion")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashiko Samplers")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sensu Quilt")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashiko Tote Bag")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kimono Quilt")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moyozashi Table Runner")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashiko Herb Pillow")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Koshi Sofa Throw")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashiko Patterns")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0